import types from './types';

const resetStore = () => ({
  type: types.RESET_STORE,
});
const setIsShowing = isShowing => ({
  type: types.SET_IS_SHOWING,
  payload: {
    isShowing,
  },
});

const setIsPlaying = isPlaying => ({
  type: types.SET_IS_PLAYING,
  payload: {
    isPlaying,
  },
});

const setAudio = audio => ({
  type: types.SET_AUDIO,
  payload: {
    audio,
  },
});

const setIsProcessing = isProcessing => ({
  type: types.SET_IS_PROCESSING,
  payload: {
    isProcessing,
  },
});
const setIsShowingCloseConfirmation = isShowingCloseConfirmation => ({
  type: types.SET_IS_SHOWING_CLOSE_CONFIRMATION,
  payload: {
    isShowingCloseConfirmation,
  },
});

const setLastSplitterPlacementPosition = lastSplitterPlacementPosition => ({
  type: types.SET_LAST_SPLITTER_PLACEMENT_POSITION,
  payload: {
    lastSplitterPlacementPosition,
  },
});

const setAudioSplitterDurationMS = audioSplitterDurationMS => ({
  type: types.SET_AUDIO_SPLITTER_DURATION_MS,
  payload: {
    audioSplitterDurationMS,
  },
});

const setAudioSplitterSplits = audioSplitterSplits => ({
  type: types.SET_AUDIO_SPLITTER_SPLITS,
  payload: {
    audioSplitterSplits,
  },
});
const addAudioSplitterSplit = audioSplitterSplit => ({
  type: types.ADD_AUDIO_SPLITTER_SPLIT,
  payload: {
    audioSplitterSplit,
  },
});
const removeAudioSplitterSplit = audioSplitterSplit => ({
  type: types.REMOVE_AUDIO_SPLITTER_SPLIT,
  payload: {
    audioSplitterSplit,
  },
});

const setAudioSplitterSplitter = audioSplitterSplitter => ({
  type: types.SET_AUDIO_SPLITTER_SPLITTER,
  payload: {
    audioSplitterSplitter,
  },
});

const setAudioSplitterActiveSplitId = audioSplitterActiveSplitId => ({
  type: types.SET_AUDIO_SPLITTER_ACTIVE_SPLIT_ID,
  payload: {
    audioSplitterActiveSplitId,
  },
});

const setAudioSplitterIsShowingSplitButton = audioSplitterIsSHowingSplitButton => ({
  type: types.SET_AUDIO_SPLITTER_IS_SHOWING_SPLIT_BUTTON,
  payload: {
    audioSplitterIsSHowingSplitButton,
  },
});

export default {
  setIsProcessing,
  resetStore,
  setIsShowing,
  setIsPlaying,
  setIsShowingCloseConfirmation,
  setAudio,
  setLastSplitterPlacementPosition,
  setAudioSplitterDurationMS,
  setAudioSplitterSplits,
  addAudioSplitterSplit,
  removeAudioSplitterSplit,
  setAudioSplitterSplitter,
  setAudioSplitterActiveSplitId,
  setAudioSplitterIsShowingSplitButton,
};
